;( function( $, undefined )
{
    $.fn.ConfirmationPage = function()
    {
        var title = $( '#confirmation-page-messages' ).find( 'h1' ).text();

        $( '.lia-form-submit' ).find( '.lia-button-wrapper-Submit-action' ).detach().appendTo( '.lia-form-submit' );
        $( '.lia-form-fieldset-wrapper' ).find( 'legend' ).after( '<h2>' + title + '</h2>' );
    };

} )( jQuery );